export const getQueryParamValue = (paramName) => {
  try {
    const { search } = window.location;

    const params = new URLSearchParams(search);

    const result = params.get(paramName);

    if (result) {
      return result;
    }

    return null;
  } catch (e) {
    return null;
  }
};
